import fetcher, { paramsFormer } from 'utils/fetcher';
import { SET_LOADING_HEADER } from 'utils/fetcher/contants';
import { ResponseFetcher } from 'utils/fetcher/types';
import { API_ALUMNOSCURSOS, API_CURSOS, API_GESTORESCURSOS, API_FORMADORESCURSOS } from 'variables';
import { API_FILTROS, API_USUARIOSPERFIL, API_VALIDARFOTO, APP_CLIENT_ID, APP_CLIENT_SECRET } from 'variables';

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getAlumnosCurso
export const getAlumnosCursoRequest = async (
  requestBody: any /* GetInstructoresPracticasRequest */
): Promise<ResponseFetcher<any /* InstructorPractica[] */>> =>
  fetcher({
    url: `${API_ALUMNOSCURSOS}getAlumnosCurso?${paramsFormer(requestBody)}`,
    options: {
      headers: SET_LOADING_HEADER,
    },
  });

export const getAlumnosCursoCountRequest = async (
  requestBody: any /* GetInstructoresPracticasRequest */
): Promise<ResponseFetcher<any /* InstructorPractica[] */>> =>
  fetcher({
    url: `${API_ALUMNOSCURSOS}getAlumnosCursosCount?${paramsFormer(
      requestBody
    )}`,
    options: {
      headers: SET_LOADING_HEADER,
    },
  });

export const getCursosRequest = async (
  requestBody: any /* GetInstructoresPracticasRequest */
): Promise<ResponseFetcher<any /* InstructorPractica[] */>> =>
  fetcher({
    url: `${API_CURSOS}getListadoCursos?${paramsFormer(requestBody)}`,
    options: {
      headers: SET_LOADING_HEADER,
    },
  });

export const getCursosCountRequest = async (
  requestBody: any /* GetInstructoresPracticasRequest */
): Promise<ResponseFetcher<any /* InstructorPractica[] */>> =>
  fetcher({
    url: `${API_CURSOS}getListadoCursosCount?${paramsFormer(requestBody)}`,
    options: {
      headers: SET_LOADING_HEADER,
    },
  });

export const getFilterProvinciasCursosRequest = async (
  requestBody: any /* GetInstructoresPracticasRequest */
): Promise<ResponseFetcher<any /* InstructorPractica[] */>> =>
  fetcher({
    url: `${API_CURSOS}getFilterProvinciasCursos?${paramsFormer(requestBody)}`,
    options: {},
  });

export const getFilterComboCursosRequest = async (
  requestBody: any /* GetInstructoresPracticasRequest */
): Promise<ResponseFetcher<any /* InstructorPractica[] */>> =>
  fetcher({
    url: `${API_CURSOS}getFilterComboCursos?${paramsFormer(requestBody)}`,
    options: {},
  });

export const getReportCoursesClosingRequest = async (
  requestBody: any /* GetInstructoresPracticasRequest */
): Promise<ResponseFetcher<any /* InstructorPractica[] */>> =>
  fetcher({
    url: `${API_CURSOS}getCursosPendientesCierre?${paramsFormer(requestBody)}`,
    options: {
      headers: SET_LOADING_HEADER,
    },
  });

export const getReportCoursesClosingCountRequest = async (
  requestBody: any /* GetInstructoresPracticasRequest */
): Promise<ResponseFetcher<any /* InstructorPractica[] */>> =>
  fetcher({
    url: `${API_CURSOS}getCursosPendientesCierreCount?${paramsFormer(
      requestBody
    )}`,
    options: {
      headers: SET_LOADING_HEADER,
    },
  });

export const getReportCoursesClosingProvinciasRequest = async (
  requestBody: any /* GetInstructoresPracticasRequest */
): Promise<ResponseFetcher<any /* InstructorPractica[] */>> =>
  fetcher({
    url: `${API_CURSOS}getFilterProvinciasCursosPendientes?${paramsFormer(
      requestBody
    )}`,
    options: {},
  });

export const setCourseStatusRequest = async (
  requestBody: any /* IChangeCourseStatusParams */
): Promise<ResponseFetcher<any /* InstructorPractica[] */>> =>
  fetcher({
    url: `${API_CURSOS}cambioEstadoCurso`,
    options: {
      method: 'POST',
      body: JSON.stringify(requestBody),
    },
  });


  //panel administracion
  //gestores
  // https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getAlumnosCurso
  export const getAllGestoresRequest = async (
  ): Promise<ResponseFetcher<any>> =>
    fetcher({
      url: `${API_GESTORESCURSOS}getAllGestores`,
      options: {
        headers: SET_LOADING_HEADER,
      },
    });

	export const postGestoresCursosRequest = async (
    requestBody: any,
    token: string
  ): Promise<ResponseFetcher<any>> => {
    const res = await fetch(`${API_GESTORESCURSOS}postGestorCurso`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        Authorization: token,
          clientId: APP_CLIENT_ID,
          clientSecret: APP_CLIENT_SECRET,
      },
      body: JSON.stringify(requestBody),
    });

    return {
      ok: res.ok,
      code: res.status,
      url: res.url,
      data: null,
    };
  };

	export const deleteGestoresCursosRequest = async (
    requestBody: any,
    token: string
  ): Promise<ResponseFetcher<any>> => {
    const res = await fetch(`${API_GESTORESCURSOS}deleteGestoresCursos`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        Authorization: token,
          clientId: APP_CLIENT_ID,
          clientSecret: APP_CLIENT_SECRET,
      },
      body: JSON.stringify(requestBody),
    });

    return {
      ok: res.ok,
      code: res.status,
      url: res.url,
      data: null,
    };
  };

    //formadores
    export const getAllFormadoresRequest = async (
    ): Promise<ResponseFetcher<any>> =>
    fetcher({
      url: `${API_FORMADORESCURSOS}getAllFormadores`,
      options: {
        headers: SET_LOADING_HEADER,
      },
    });

    export const postFormadoresCursosRequest = async (
     requestBody: any,
     token: string
  ): Promise<ResponseFetcher<any>> => {
    const res = await fetch(`${API_FORMADORESCURSOS}postFormadorCurso`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        Authorization: token,
          clientId: APP_CLIENT_ID,
          clientSecret: APP_CLIENT_SECRET,
      },
      body: JSON.stringify(requestBody),
    });

    return {
      ok: res.ok,
      code: res.status,
      url: res.url,
      data: null,
    };
  };

    export const deleteFormadoresCursosRequest = async (
     requestBody: any,
     token: string
  ): Promise<ResponseFetcher<any>> => {
    const res = await fetch(`${API_FORMADORESCURSOS}deleteFormadoresCursos`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        Authorization: token,
          clientId: APP_CLIENT_ID,
          clientSecret: APP_CLIENT_SECRET,
      },
      body: JSON.stringify(requestBody),
    });

    return {
      ok: res.ok,
      code: res.status,
      url: res.url,
      data: null,
    };
  };

    //alumnos
  export const getAllAlumnosRequest = async (
    ): Promise<ResponseFetcher<any>> =>
    fetcher({
      url: `${API_ALUMNOSCURSOS}getAllAlumnos`,
      options: {
        headers: SET_LOADING_HEADER,
      },
    });


  export const postAlumnosCursosRequest = async (
    requestBody: any,
     token: string
  ): Promise<ResponseFetcher<any>> => {
    const res = await fetch(`${API_ALUMNOSCURSOS}postAlumnoCurso`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        Authorization: token,
          clientId: APP_CLIENT_ID,
          clientSecret: APP_CLIENT_SECRET,
      },
      body: JSON.stringify(requestBody),
    });

    return {
      ok: res.ok,
      code: res.status,
      url: res.url,
      data: null,
    };
  };

  export const deleteAlumnosCursosRequest = async (
    requestBody: any,
     token: string
  ): Promise<ResponseFetcher<any>> => {
    const res = await fetch(`${API_ALUMNOSCURSOS}deleteAlumnosCursos`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        Authorization: token,
          clientId: APP_CLIENT_ID,
          clientSecret: APP_CLIENT_SECRET,
      },
      body: JSON.stringify(requestBody),
    });

    return {
      ok: res.ok,
      code: res.status,
      url: res.url,
      data: null,
    };
  };
